import { Icon } from '@iconify/react';
import { humanize } from '../../vmsConstants';

// One pill for every VMS status and type. Each screen passes its own style map
// (from vmsConstants) so the colours stay declared as literal Tailwind classes
// that the JIT compiler can see.
const VmsBadge = ({
    value,
    styles = {},
    icons,
    label,
    title,
    fallback = 'tw-bg-gray-100 tw-text-gray-600',
    className = '',
}) => {
    if (!value) return <span className="tw-text-gray-300">—</span>;

    const icon = icons?.[value];

    return (
        <span
            title={title}
            className={`tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-semibold tw-whitespace-nowrap ${styles[value] || fallback} ${className}`}
        >
            {icon && <Icon icon={icon} className="tw-text-xs" />}
            {label || humanize(value)}
        </span>
    );
};

export default VmsBadge;
